import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center",
  style: {"background-image":"url('bg.png')"}
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20"
}
const _hoisted_3 = { class: "w-lg-500px bg-white rounded shadow-lg p-10 p-lg-15 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "text-center mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-dark mb-2",
  style: {"color":"#163578 !important"}
}, " Нууц үг сэргээх ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fw-bold fs-4" }, " Нууц үгээ солихын тулд та доорх талбаруудад бүртгүүлсэн цахим шуудангийн хаяг болон хэрэглэгчийн нэрээ оруулна уу. ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "fv-row mb-10" }
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_18 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Сэргээх код илгээх ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Буцах ")
const _hoisted_23 = { style: {"margin-top":"50px"} }
const _hoisted_24 = { style: {"color":"#163578"} }
const _hoisted_25 = {
  key: 1,
  class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20"
}
const _hoisted_26 = { class: "w-lg-500px bg-white rounded shadow-lg p-10 p-lg-15 mx-auto" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "text-center mb-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", {
  class: "text-dark mb-2",
  style: {"color":"#163578 !important"}
}, " Нууц үг сэргээх ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fw-bold fs-4" }, " Хэрэглэгчийн нэр, цахим шуудангийн хаяг, цахим шуудангаар ирүүлсэн кодыг доор оруулна уу. ")
], -1)
const _hoisted_33 = { class: "fv-row mb-10" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "fv-row mb-10" }
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "fv-row mb-10" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_43 = {
  type: "submit",
  ref: "submitButtonTwo",
  id: "kt_password_reset_submit_two",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Шинэ нууц үг илгээх ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_48 = { style: {"margin-top":"50px"} }
const _hoisted_49 = { style: {"color":"#163578"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.active === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              onSubmit: _ctx.onSubmitForgotPasswordStepOne,
              ref: "stepOneForm",
              id: "kt_login_password_reset_form",
              "validation-schema": _ctx.forgotPassword
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _hoisted_7,
                  _createVNode(_component_el_steps, {
                    "finish-status": "success",
                    active: _ctx.active,
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_step, {
                        title: "Алхам 1",
                        icon: "el-icon-s-promotion"
                      }),
                      _createVNode(_component_el_step, {
                        title: "Алхам 2",
                        icon: "el-icon-message"
                      })
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]),
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "Хэрэглэгчийн нэр",
                    name: "username",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ErrorMessage, { name: "username" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "email",
                    placeholder: "Цахим шуудан",
                    name: "email",
                    ref: "stepOneEmail",
                    autocomplete: "off"
                  }, null, 512),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", _hoisted_18, _hoisted_21, 512),
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "btn btn-lg btn-light-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("h6", _hoisted_24, _toDisplayString(_ctx.copyRight), 1)
          ])
        ], 512)), [
          [_vShow, _ctx.active === 0]
        ])
      : _createCommentVNode("", true),
    (_ctx.active === 1)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              onSubmit: _ctx.onSubmitForgotPasswordStepTwo,
              id: "kt_login_password_reset_form_two",
              "validation-schema": _ctx.forgotPasswordStep2
            }, {
              default: _withCtx(() => [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _createVNode(_component_el_steps, {
                    "finish-status": "success",
                    active: _ctx.active,
                    "align-center": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_step, {
                        title: "Алхам 1",
                        icon: "el-icon-s-promotion"
                      }),
                      _createVNode(_component_el_step, {
                        title: "Алхам 2",
                        icon: "el-icon-message"
                      })
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]),
                _hoisted_31,
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "Хэрэглэгчийн нэр",
                    name: "username",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_ErrorMessage, { name: "username" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "email",
                    placeholder: "Цахим шуудан",
                    name: "email",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_ErrorMessage, { name: "email" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "Код",
                    name: "verifycode",
                    autocomplete: "off"
                  }),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_ErrorMessage, { name: "verifycode" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("button", _hoisted_43, _hoisted_46, 512),
                  _createVNode(_component_router_link, {
                    to: "/login",
                    class: "btn btn-lg btn-light-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_47
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("h6", _hoisted_49, _toDisplayString(_ctx.copyRight), 1)
          ])
        ], 512)), [
          [_vShow, _ctx.active === 1]
        ])
      : _createCommentVNode("", true)
  ]))
}